import { useTranslation } from "react-i18next";
import { Button, Empty, Spin } from 'antd'
import dayjs from 'dayjs'
import { isEmpty, toNumber } from 'lodash'
import { useEffect, useState } from 'react'
import UploadItem from '../../../../../components/course-construction/content-course-construction/statistic-course/components/comment/UploadItem'
import { DropdownIcon } from '../../../../../components/course-construction/content-course-construction/statistic-course/components/icons'
import useKeyword from '../../../../../hooks/useKeyword'
import { getDiscussReport } from '../../../../../service/course-management'
import { CommentReportType } from '../../../../../types/course'
import { AttachmentProps } from '../../../../../types/course-construction'
import { displayDateComment } from '../../../../../utils/converDate'
import DiscussionReportModal from './discussion-report-modal/DiscussionReportModal'
import DetailDiscussionReportModal from './detail-discussion-report-modal/DetailDiscussionReportModal'
import { CourseManagementStore } from '../../../../../stores/stores'
type FilterData = {
	student: string,
	timeCreated: any
}
interface Props {
	mode: string
	filterData: FilterData
}
const DiscussionReport = (props: Props) => {
  const { t } = useTranslation();
	const { mode, filterData } = props
	const unitId = toNumber(useKeyword("unitId"));
	const [comments, setComments] = useState<CommentReportType[]>([]);
	const [isViewFull, setIsViewFull] = useState<boolean>(false);
	const [isOpenDiscussionReport, setIsOpenDiscussionReport] = useState<boolean>(false)
	const [isOpenDetailDiscussion, setIsOpenDetailDiscussion] = useState<boolean>(false)
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [discussionId, setDiscussionId] = useState<number>(0)
	const { reloadDiscussion } = CourseManagementStore()
	const [reportId, setReportId] = useState<number>(0)
	const [reportLevel, setReportLevel] = useState<number>()

	useEffect(() => {
		const getComments = async () => {
			try {
				if (unitId) {
					setIsLoading(true)
					const res = await getDiscussReport({
						unitId: unitId,
						status: mode,
						keyword: filterData.student,
						createdDateFrom: !isEmpty(filterData?.timeCreated)
							? dayjs(filterData?.timeCreated?.[0])
								.toISOString()
							: undefined,
						createdDateTo: !isEmpty(filterData?.timeCreated)
							? dayjs(filterData?.timeCreated?.[1])
								.toISOString()
							: undefined,
					});
					setComments(res.data.data ? res.data.data.datas : []);
				}
			} catch (error) {

			}
			finally {
				setIsLoading(false)
			}
		};
		getComments();
	}, [unitId, mode, filterData, reloadDiscussion]);

	const getFullName = (firstName: string, lastName: string) => {
		if (firstName || lastName) return `${firstName} ${lastName}`;
		return false;
	};

	const renderHighlightedText = (text: string, username: string) => {
		if (text?.includes(username)) {
			const parts = text.split(username);
			return (
				<span>
					{parts[0].endsWith("@") ? parts[0].slice(0, -1) : parts[0]}
					<span className="font-weight-6">{username}</span>
					{parts[1]}
				</span>
			);
		}
		return text;
	};
	return (
		<>
			<Spin spinning={isLoading}>
				<div className='discussion-report'>
					{comments?.length > 0 ? comments?.map((it: CommentReportType) => {
						return <div
							key={it?.id}
							className='discussion-report-content'>
							<div className="flex gap-8">
								<img
									className="avt-comment"
									src={
										it.avatar ||
										`${process.env.PUBLIC_URL}/images/comment-avatar.png`
									}
									alt="avt"
								/>
								<div className='flex-1'>
									<div className="flex align-center justify-between gap-8">
										<div className='flex align-center'>
											<span className="text-user-name">
												{getFullName(
													it?.author?.firstName as string,
													it?.author?.lastName as string
												)}
											</span>
											<span className="text-time ml-1">
												{displayDateComment(it.createdDate || "")}
											</span>
										</div>
										<div className='flex gap-8 align-center'>
											<Button
												onClick={() => {
													setIsOpenDetailDiscussion(true)
													setDiscussionId(it.discussionId)

												}}
											>{t("Xem toàn bộ thảo luận", "Xem toàn bộ thảo luận")}</Button>
											<Button
												type='primary'
												onClick={() => {
													setIsOpenDiscussionReport(true)
													setReportId(it.reportId)
													setReportLevel(it.level)
												}
												}
											>{t("Xử lý", "Xử lý")}</Button>
										</div>
									</div>

									<div
										className={`comment-content flex-1 mt-3 ${isViewFull ? "h-full" : ""}`}
									>
										<span className="text-content">
											{renderHighlightedText(
												it?.content as string,
												it?.author?.username as string
											)}
										</span>
										<div className="comment-attachments">
											{it?.attachments?.map((item: AttachmentProps) => (
												<UploadItem
													canDownload
													key={item.id}
													file={{
														name: item.fileName,
														preview: item.mainKey,
														type: item.attachmentType,
													}}
												/>
											))}
										</div>
										{isViewFull && (
											<span
												className={`text-primary flex align-center pointer pl-3 btn-loadmore`}
												onClick={() => setIsViewFull(!isViewFull)}
											>
												<DropdownIcon />
												<span className="ml-1"> {t("Chi tiết", "Chi tiết")}</span>
											</span>
										)}
									</div>
								</div>
							</div>

						</div>
					}
					)
						:
						<div className="statistic-course-discuss-empty">
							<Empty description={t("Không có bình luận", "Không có bình luận")}></Empty>
						</div>
					}
					<DiscussionReportModal
						open={isOpenDiscussionReport}
						handleCancel={() => setIsOpenDiscussionReport(false)}
						reportId={reportId}
						reportLevel={reportLevel}
					/>

					<DetailDiscussionReportModal
						discussionId={discussionId}
						open={isOpenDetailDiscussion}
						handleCancel={() => setIsOpenDetailDiscussion(false)}
					/>
				</div>
			</Spin>
		</>
	)
}

export default DiscussionReport